import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
// import Application from '../pdf/Application.pdf';
// import Application from '../pdf/ApplicationForm.pdf'
// import Application from '../pdf/Application.pdf''
import OfferLetterpdf from '../pdf/OfferLetter.pdf'
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import icon from '../All/images/tick-icon.png';
// import icon from '../All/images/tick-icon.png';
// import fs from 'fs';
import fontkit from '@pdf-lib/fontkit';  // Import fontkit for custom fonts
// import poppins from '../fonts/Poppins-Regular.ttf';
// import poppinsBold from '../fonts/Poppins-Bold.ttf';
import axios from '../Axiosinstance'
import { removeBracketedText } from '../Axiosinstance';
import TimesRoman from '../fonts/Times-Roman.ttf';

const OfferLetter = forwardRef((dataProp, ref) => {
    const formatDateNumeric = (dateObj) => {
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };


const drawWrappedText = (
    page,
    text,
    x,
    y,
    maxWidth,
    lineHeight,
    font,
    fontSize
) => {
    const words = text.split(' ');
    let line = '';
    let currentY = y;

    words.forEach((word) => {
        const testLine = line ? `${line} ${word}` : word;
        const textWidth = font.widthOfTextAtSize(testLine, fontSize);

        if (textWidth > maxWidth) {
            page.drawText(line, {
                x,
                y: currentY,
                size: fontSize,
                font,
                color: rgb(0, 0, 0),
            });

            line = word;
            currentY -= lineHeight;
        } else {
            line = testLine;
        }
    });

    if (line) {
        page.drawText(line, {
            x,
            y: currentY,
            size: fontSize,
            font,
            color: rgb(0, 0, 0),
        });
    }
};


    const handleDownload = async (student) => {
        console.log("student:", student);
        try {
            const pdfBytes = await fetch(OfferLetterpdf).then(res => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(pdfBytes);

            pdfDoc.registerFontkit(fontkit);

            const TimesRomanfont = await fetch(TimesRoman).then(res => res.arrayBuffer());
            const Timesfont = await pdfDoc.embedFont(TimesRomanfont);



            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
            const fontSize = 10;

            const formatDate = (dateString) => {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            };

            // Prepare data
            const studentName = (student?.name || '').toUpperCase();
            const Nric = student?.nric || '';
            const customId = student?.customId || '';
            const DOB = formatDate(student?.dob);
            const address = student?.address || '';
            const course = removeBracketedText((student?.course || '')).toUpperCase();
            const offerDate = formatDate(student?.offerDate);
            const courseFee = (student?.courseFee ?? 0).toString();
            const scheduleDate = student?.scheduleDate || [];
            let startDateStr = '', endDateStr = '';
            if (Array.isArray(scheduleDate) && scheduleDate.length > 0) {
                const startDate = new Date(scheduleDate[0].startDate);
                const oneYearLater = new Date(startDate);
                oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
                const endDate = new Date(oneYearLater.getTime() - (24 * 60 * 60 * 1000));

                startDateStr = formatDateNumeric(startDate);
                endDateStr = formatDateNumeric(endDate);
            }
            // Insert data into PDF
            firstPage.drawText(offerDate, { x: 102, y: 650, size: 10, font: Timesfont, color: rgb(0, 0, 0) });
            firstPage.drawText(studentName, { x: 101, y: 632, size: 10, font: Timesfont, color: rgb(0, 0, 0) });
            firstPage.drawText(studentName, { x: 311, y: 532, size: 10, font: Timesfont, color: rgb(0, 0, 0) });
            firstPage.drawText(address, { x: 118, y: 613.5, size: 11, font: Timesfont, color: rgb(0, 0, 0) });

            firstPage.drawText(Nric, { x: 311, y: 509, size: 10, font: Timesfont, color: rgb(0, 0, 0) });
            firstPage.drawText(customId, { x: 311, y: 487, size: 10, font: Timesfont, color: rgb(0, 0, 0) });
            firstPage.drawText(DOB, { x: 311, y: 464, size: 10, font: Timesfont, color: rgb(0, 0, 0) });

drawWrappedText(
    firstPage,
    course,
    311,   // X
    441,   // Y
    230,   // Width of Course Offered column
    12,    // Line spacing
    Timesfont,
    fontSize
);
            firstPage.drawText(courseFee, { x: 312, y: 353, size: 10, font: Timesfont, color: rgb(0, 0, 0) });
            firstPage.drawText(startDateStr, { x: 313, y: 326.5, size: 10, font: Timesfont, color: rgb(0, 0, 0) });
            firstPage.drawText(endDateStr, { x: 313, y: 313.5, size: 10, font: Timesfont, color: rgb(0, 0, 0) });

            // Save and open
            const pdfBytesModified = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };



    useImperativeHandle(ref, () => ({ handleDownload }));

    return null;
});

export default OfferLetter;
